export default __webpack_public_path__ + "static/media/pictogramOnline40.e161d51c.svg";